import type { ContentBlock } from '../types';

/** Deep-replace {{key}} placeholders in all string values within a blocks array. */
export function interpolateBlocks(blocks: ContentBlock[], vars: Record<string, string>): ContentBlock[] {
  const replacer = (s: string) => s.replace(/\{\{(\w+)\}\}/g, (_, k: string) => vars[k] ?? '');
  function walk(obj: unknown): unknown {
    if (typeof obj === 'string') return replacer(obj);
    if (Array.isArray(obj)) return obj.map(walk);
    if (obj && typeof obj === 'object') {
      const out: Record<string, unknown> = {};
      for (const [k, v] of Object.entries(obj)) out[k] = walk(v);
      return out;
    }
    return obj;
  }
  return walk(blocks) as ContentBlock[];
}
